enum ReactQueryKeys {
  GET_ACCOUNT_INFORMATION = 'getAccountInformation',
}

export { ReactQueryKeys };
